import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// สิทธิ์ที่ guard ต้องการ → ข้อความที่ผู้ใช้อ่านรู้เรื่อง
const ROLE_LABELS = {
  th: { admin: "ผู้ดูแลระบบ", staff: "พนักงาน", store: "คลังอะไหล่" },
  en: { admin: "Administrator", staff: "Staff", store: "Store" },
};

const ForbiddenScreen = ({ required }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const label = ROLE_LABELS[i18n.language?.startsWith("en") ? "en" : "th"][required] || required;

  return (
    // 403 ถูก render อยู่ใน ContainerLayout ซึ่งมี hero banner อยู่แล้ว จึงใช้ 60vh ไม่ใช่ min-h-screen
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="text-7xl mb-4">🔒</div>
        <h1 className="text-4xl font-bold text-slate-800 mb-2">403</h1>
        <p className="text-slate-600 mb-2">
          {t("errors.forbidden")}
        </p>
        {label && (
          <p className="text-sm text-slate-500 mb-6">
            {t("errors.needPermission")} <span className="font-semibold text-slate-700">{label}</span>
            <br />
            <span className="text-xs text-slate-400">
              {t("errors.askAdmin")}
            </span>
          </p>
        )}
        <div className="flex gap-2 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-semibold"
          >
            ← {t("common.back")}
          </button>
          <button
            onClick={() => navigate("/")}
            className="px-4 py-2 hover: rounded-lg font-semibold btn-apple-primary"
          >
            🏠 {t("nav.home")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenScreen;
